import { render } from "./DocCenter.vue?vue&type=template&id=3887e4d6&scoped=true"
import script from "./DocCenter.vue?vue&type=script&lang=js"
export * from "./DocCenter.vue?vue&type=script&lang=js"

import "./DocCenter.vue?vue&type=style&index=0&id=3887e4d6&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3887e4d6"]])

export default __exports__